<span
  class="star-rating"
  [class]="size"
  [ngStyle]="starStyles"
  [attr.aria-label]="rating + ' von 5 Sternen'"
  role="img"
></span>
